/* eslint-disable @typescript-eslint/no-explicit-any */

"use client";

import * as React from "react";
import Image from "next/image";
import { designData } from "@/data/design.data";
import Masonry from "../shared/masonary/Masonry";

type MasonryItem = {
  id: string;
  img: string;
  url: string;
  height: number;
  title?: string;
  tags?: string[];
  priority?: boolean;
};

/** Visual variety for item heights (px). Adjust to taste. */
const HEIGHTS_MD: number[] = [440, 320, 600, 300, 380, 520, 280, 360];
const HEIGHTS_SM: number[] = [360, 260, 400, 240, 300, 340, 240, 280];

function getHeight(idx: number, isDesktop = true) {
  const src = isDesktop ? HEIGHTS_MD : HEIGHTS_SM;
  return src[idx % src.length] ?? (isDesktop ? 380 : 280);
}

export default function Design() {
  // ✅ call the function (bugfix)
  const { items } = designData;

  const masonryItems: MasonryItem[] = items.map((p: any, idx: number) => ({
    id: String(p.id ?? idx),
    img: p.image,
    url: p.href || "#",
    height: getHeight(idx, true),
    title: p.title,
    tags: p.tags,
    priority: idx === 0, // first item eager-load
  }));

  return (
    <section id="design">
      {/* <Heading title={title} className="mb-6" /> */}

      <Masonry
        items={masonryItems}
        ease="power3.out"
        duration={0.6}
        stagger={0.01}
        animateFrom="bottom"
        scaleOnHover={true}
        hoverScale={0.95}
        blurToFocus={false}
        colorShiftOnHover={false}
        renderItem={(it, i) => (
          <figure className="relative">
            <div
              className={[
                "relative overflow-hidden bg-black border border-border rounded",
                "h-[var(--h-sm)] md:h-[var(--h-md)]",
              ].join(" ")}
              style={
                {
                  "--h-sm": `${getHeight(i, false)}px`,
                  "--h-md": `${it.height}px`,
                } as React.CSSProperties
              }
            >
              <Image
                src={it.img}
                alt={it.title || "Design image"}
                fill
                sizes="(min-width: 768px) 33vw, 100vw"
                className="object-cover transition-transform duration-300 group-hover:scale-[1.03]"
                priority={!!it.priority}
              />
            </div>
          </figure>
        )}
      />
    </section>
  );
}
